<template>
  <div class="activities">
    <div class="title">
      <div></div>
      账号管理
    </div>
    <div class="query">
      <div class="query-box">
        <span>输入</span>
        <el-input v-model="name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="query-box">
        <span>日期</span>
        <el-date-picker
          v-model="activityTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
           @change='querys'
        >
        </el-date-picker>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
    </div>
    <div class="top-btn">
      <el-button icon="el-icon-plus" type="primary" @click="getRole"
        >新增</el-button
      >
      <el-button icon="el-icon-refresh" type="primary" @click="refresh"
        >刷新</el-button
      >
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="name" label="姓名">
        </el-table-column>
        <el-table-column align="center" prop="phone" label="电话">
        </el-table-column>
        <el-table-column align="center" prop="userName" label="账号">
        </el-table-column>
        <!-- <el-table-column align="center" prop="password" label="密码">
        </el-table-column> -->
        <el-table-column align="center" prop="roleName" label="角色">
        </el-table-column>
        <el-table-column align="center" prop="infoTime" label="创建时间">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 新增 -->
    <el-dialog title="创建账号" :visible.sync="addDialog" width="30%" center>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="姓名" label-width="80px" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" label-width="80px" prop="phone">
          <el-input v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="账号" label-width="80px" prop="userName">
          <el-input v-model="form.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="80px" prop="password">
          <el-input v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" label-width="80px" prop="roleId">
          <el-select v-model="form.roleId" placeholder="请选择角色">
            <el-option
              :label="item.describes"
              :value="item.id"
              v-for="(item, i) in roleLists"
              :key="i"
              >{{ item.describes }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addRole('form')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑角色" :visible.sync="editDialog" width="30%" center>
      <el-form :model="eaidForm" :rules="rules" ref="eaidForm">
        <el-form-item label="姓名" label-width="80px" prop="name">
          <el-input v-model="eaidForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" label-width="80px" prop="phone">
          <el-input v-model="eaidForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="账号" label-width="80px" prop="userName">
          <el-input v-model="eaidForm.userName" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码" label-width="80px">
          <el-input v-model="eaidForm.password" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="角色" label-width="80px" prop="roleId">
          <el-select v-model="eaidForm.roleId" placeholder="请选择角色">
            <el-option
              :label="item.describes"
              :value="item.id"
              v-for="(item, i) in roleLists"
              :key="i"
              >{{ item.describes }}</el-option
            >
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editRole('eaidForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import reg from "@/utils/reg.js";
import { roleList, addAcc, accList, accDel, update } from "@/api/api";
export default {
  data() {
    let letterRule = (rule, value, callback) => {
      let reg = /^[a-zA-Z0-9_-]{4,18}$/;
      if (value === "") {
        callback(new Error("输入内容不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入字母、数字、下划线"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      let reg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (value === "") {
        callback(new Error("输入内容不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    };
    return {
      name: "",
      startTime: "",
      endTime: "",
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      // 新增
      addDialog: false,
      editDialog: false,
      form: {
        name: "",
        phone: "",
        userName: "",
        password: "",
        roleId: "",
      },
      eaidForm: {},
      // 角色列表
      roleLists: [],
      rules: {
        //验证规则
           name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20个字符",
            trigger: "blur",
          },
          // {validator: letterRule, trigger: 'blur'}
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
          // {validator: letterRule, trigger: 'blur'}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
          { validator: letterRule, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
           roleId: [
          { required: true, message: "请选择角色", trigger: "blur" },
        
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
       querys(){
       if(this.activityTime==null){
         this.startTime='',
          this.endTime=''
       }
    },
    // 角色列表
    async getRoles() {
      let res = await roleList();
      // console.log(res)
      this.roleLists = res.data;
    },
    // 新增
    getRole() {
      this.addDialog = true;
      this.getRoles();
    },

    //新增确定
    addRole: reg._debounce(function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await addAcc({
            roleId: this.form.roleId,
            name: this.form.name,
            phone: this.form.phone,
            userName: this.form.userName,
            password: this.form.password,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.form.roleId = "";
            this.form.name = "";
            this.form.phone = "";
            this.form.userName = "";
            this.form.password = "";
            this.getList();
            this.addDialog = false;
          }
        }
      });
    }, 200),
    // 获取列表
    async getList() {
      let res = await accList({
        name: this.name,
        startTime: this.startTime,
        endTime: this.endTime,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      if (this.activityTime) {
        (this.startTime = moment(this.activityTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        )),
          (this.endTime = moment(this.activityTime[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          ));
      }
      this.getList();
    },
    // 刷新
    refresh() {
      this.name = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },

    //   删除
    handleDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { code } = await accDel({ id });
          if (code === 200) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //编辑
    handleEdit(row) {
      this.eaidForm = { ...row };
      this.getRoles();
      this.editDialog = true;
    },
    // 编辑确定
    editRole(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await update(this.eaidForm);
          if (res.code == 200) {
            this.editDialog = false;
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.getList();
          } else {
            $message.error(res.msg);
          }
        }
      });
    },
    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .top-btn {
    margin: 15px 0;
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
</style>